import {
  Checkbox as ChakraCheckbox,
  CheckboxGroup as ChakraCheckboxGroup,
  CheckboxGroupProps,
  CheckboxProps as ChakraCheckboxProps,
  SimpleGrid,
} from '@chakra-ui/react';
import React from 'react';

export enum CheckboxesSize {
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
}

interface CheckboxOptionProps {
  label: string;
  value: string;
  isChecked?: boolean;
}

interface CheckboxesProps
  extends Pick<CheckboxGroupProps, 'defaultValue' | 'value'> {
  name: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  options: CheckboxOptionProps[];
  size?: CheckboxesSize;
  component?: React.ComponentType<ChakraCheckboxProps>;
  columns?: number | number[];
  variant?: 'primary';
}

// This component will likely not be part of the design library and will live here temporarily
const Checkboxes: React.FC<CheckboxesProps> = ({
  options = [],
  size,
  component = ChakraCheckbox,
  columns,
  onBlur,
  onChange,
  name,
  variant,
  ...rest
}) => {
  const handleChange = React.useCallback(
    (value: (string | number)[]) => {
      onChange?.({ target: { name, value } } as any);
    },
    [name, onChange],
  );
  const handleBlur = React.useCallback(
    () => onBlur?.({ target: { name } } as any),
    [name, onBlur],
  );
  const CheckboxComponent = component;
  return (
    <ChakraCheckboxGroup {...rest} variant={variant} onChange={handleChange}>
      <SimpleGrid spacing={4} columns={columns || options.length}>
        {options.map(({ label, value }, index) => (
          <CheckboxComponent
            size={size}
            key={index}
            value={value}
            onBlur={handleBlur}
          >
            {label}
          </CheckboxComponent>
        ))}
      </SimpleGrid>
    </ChakraCheckboxGroup>
  );
};

export default Checkboxes;
